<template>
  <div class="input">
    <div
      class="input__input"
      ref="editable"
      contenteditable
      v-on="listeners"
      @keypress="onKeyPress"
    />

    <label class="input__label">Participe do chat!</label>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    sendsOnEnter: { type: Boolean, default: true },
    maxLength: { type: Number, default: null },
    readonly: { type: Boolean, default: false }
  },

  mounted() {
    this.$refs.editable.innerHTML = this.value
  },

  computed: {
    listeners() {
      return { ...this.$listeners, input: this.onInput }
    }
  },

  watch: {
    value(value) {
      const text = this.$refs.editable.innerText.replace(/\u00a0/g, " ")
      if (text !== value) {
        this.$refs.editable.innerHTML = value
      }
    }
  },

  methods: {
    onKeyPress(event) {
      if (this.readonly) {
        return event.preventDefault()
      }

      if (this.sendsOnEnter && event.key === 'Enter') {
        event.preventDefault()
        this.$emit('submit')
      }

      if (this.maxLength && this.$refs.editable.innerText.length >= this.maxLength) {
        event.preventDefault()        
      }
    },

    onInput(event) {
      const text = event.target.innerText.replace(/\u00a0/g, " ")
      
      this.$emit('input', text)
    },
  },
}
</script>

<style lang="scss" scoped>
  .input {
    $p: &;
    position: relative;

    &__label {
      position: absolute;
      top: 0;
      left: 0;
      font-family: Poppins;
      font-size: 14px;
      color: #474747;
    }

    &__input {
      position: relative;
      z-index: 1;
      border-bottom: 2px solid #C6C6C6;
      max-height: 150px;
      overflow: auto;
      color: #474747;
      font-size: 14px;
      font-family: Poppins;
      padding-bottom: 8px;

      &:focus {
        border-color: #ff8000
      }

      &:not(:empty) + #{$p}__label {
        display: none;
      }
    }
  }
</style>